import React, { useState, useRef, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useAuth } from '../../contexts/auth';
import eye from "../../assets/icons/eye.svg";
import eyeOff from "../../assets/icons/eye-off.svg";
import './login-form.scss';
import Toast from 'components/Toast';

export default function LoginForm() {
  const [passwordState, setPasswordState] = useState('password');
  const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: passwordState,  buttons: [{
    name: 'trash',
    location: 'after',
    options: {
      stylingMode: 'text',
      icon: (passwordState === 'password' ? eyeOff : eye),
      onClick: () => {
        setPasswordState(passwordState === 'password' ? 'text' : 'password')
      },
    },
    }],
  }
  const history = useHistory();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);
  const formData = useRef({});
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 2000,
  });

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    await setPasswordState('password')
    const { email, password } = formData.current;
    setLoading(true);

    const result = await signIn(email, password);
    if (!result.isOk) {
      setLoading(false);
      
      await setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: 'error',
        status: 400,
        message: result.message,
      });
    }
    // setTimeout(window.location.reload(), 5000);
    
  }, [signIn]);

  const onCreateAccountClick = useCallback(() => {
    history.push('/create-account');
  }, [history]);

  return (
    <>
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={'email'}
          editorType={'dxTextBox'}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="Email is required" />
          <EmailRule message="Email is invalid" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
          label={{ visible: false }}
        >
          <RequiredRule message="Password is required" />
        </Item>
        {/* <Item
          dataField={'rememberMe'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item> */}
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
            elementAttr={{ class: 'custom-signin-button' }}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Sign In'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={'link'}>
            <Link to={'/reset-password'}>Forgot password?</Link>
          </div>
        </Item>
      </Form>
    </form>
  <Toast
  setParentToastConfig={setToastConfig}
  toastBody={toastConfig}
/>
</>    
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };
const rememberMeEditorOptions = { text: 'Remember me', elementAttr: { class: 'form-text' } };
